
export const environment = {
  encryptionKey: 'somethingsomething',
    apiUrl: 'https://mobile-api-layer.s2qa.com/xml_api_2_9_1',
    production: false,
    buildVersion: '1.19.1.3',
    nameAppend: '_MOB',
    buildNumber: 1,
    devLoginCredentials: '1171,abid.riaz.s2,Appleseed1',
    isJLLBuild: '0'
};
